import clsx from 'clsx';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { FunctionComponent } from 'react';
import styles from './AppointmentsExportCSVModalItem.module.scss';

interface AppointmentsExportCSVModalItemProps {
    label: string;
    selected: boolean;
    className?: string;
    onClick?: (checked: boolean) => void;
}

export const AppointmentsExportCSVModalItem: FunctionComponent<AppointmentsExportCSVModalItemProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <Checkbox
                checked={props.selected}
                onChange={props.onClick}
            />
            <span className={styles.label}>{props.label}</span>
        </div>
    );
};

export default AppointmentsExportCSVModalItem;
